<!-- 查看开设系统 -->
<template>
    <el-dialog
        :visible="viewIsReady"
        @close="handleClose"
        title="开设系统"
        width="600px"
    >

        <ul class="cell-list">
            <li v-for="item in params"
                :key="item"
            >{{item}}</li>
        </ul>

        <div slot="footer">
            <el-button @click="handleClose" type="primary">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'ViewParams',
    props: ["params"],

    data () {
        return {
            viewIsReady: false,
            info: []
        }
    },

    watch: {
        params (params, old) {
            if (params && params !== old) {
                this.viewIsReady = true;
                this.info = params;
            }
        }
    },

    methods: {
        handleClose () {
            this.viewIsReady = false;
            this.info = [];
            this.$emit("update:params", null);
        }
    }
}
</script>

<style lang='scss' scoped>
    .cell-list {
        line-height: 1.5;

        // li {
        //     white-space: nowrap;
        //     overflow: hidden;
        //     text-overflow: ellipsis;
        // }

        li:nth-child(n+2) {
            margin-top: 10px;
        }
    }
</style>